import Vue from 'vue'
import { URL_FILES } from '@/constants/urls.js'
import { MYME_TYPES } from '@/constants/settings.js'
import { IDENTITY_FILES, ERRORS, AXIOS_REQUESTS, GENERAL_FILES } from '@/constants/store.js'

const state = {
  [IDENTITY_FILES.STATE.REQUEST_FILES]: [],
  [IDENTITY_FILES.STATE.REQUIRED_DOCUMENT_TYPES]: [],
  [IDENTITY_FILES.STATE.CURRENT_FILE]: null
}

const actions = {
  async [IDENTITY_FILES.ACTIONS.DOWNLOAD_IDENTITY_FILE] ({ commit, dispatch }, model) {
    const url = `${Vue.getIdentityHost()}${URL_FILES}/${model.fileId}?${Vue.helpers.getQueryParamsString()}`

    await dispatch(GENERAL_FILES.ACTIONS.DOWNLOAD_FILE_WITH_SETTINGS, url, { root: true })
  },
  async [IDENTITY_FILES.ACTIONS.UPLOAD_IDENTITY_FILE] ({ commit, dispatch }, model) {
    const documentType = model.documentType
    model = {
      url: `${Vue.getIdentityHost()}${URL_FILES}/signable`,
      model: model.form,
      settings: { headers: { 'Content-Type': MYME_TYPES.FORM_DATA } }
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(IDENTITY_FILES.MUTATIONS.ADD_FILE_TO_STORE_LIST, { ...resp.data, documentType })
    return resp.data
  },
  async [IDENTITY_FILES.ACTIONS.UPLOAD_SINGLE_IDENTITY_FILE] ({ commit, dispatch }, model) {
    const documentType = model.documentType
    model = {
      url: `${Vue.getIdentityHost()}${URL_FILES}/signable`,
      model: model.form,
      settings: { headers: { 'Content-Type': MYME_TYPES.FORM_DATA } }
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })

    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(IDENTITY_FILES.MUTATIONS.UPLOAD_SINGLE_IDENTITY_FILE, { ...resp.data, documentType })
  },
  async [IDENTITY_FILES.ACTIONS.DELETE_IDENTITY_FILE] ({ commit, dispatch }, model) {
    const fileId = model.fileId
    model = {
      url: `${Vue.getIdentityHost()}${URL_FILES}/${fileId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(IDENTITY_FILES.MUTATIONS.DELETE_FILE_FROM_STORE_LIST, fileId)
  },
  async [IDENTITY_FILES.ACTIONS.GET_REQUEST_FILES] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_FILES}/${model.requestType}/${model.objectId}/requestFiles?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(IDENTITY_FILES.MUTATIONS.GET_REQUEST_FILES, resp.data || [])
  },
  async [IDENTITY_FILES.ACTIONS.LINK_REQUEST_FILE] ({ commit, dispatch }, model) {
    model.url = `${Vue.getIdentityHost()}${URL_FILES}/${model.requestType}/${model.objectId}/requestFiles`
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [IDENTITY_FILES.ACTIONS.GET_REQUIRED_DOCUMENT_TYPES] ({ commit, dispatch }, model) {
    model = {
      url: `${Vue.getIdentityHost()}${URL_FILES}/${model.requestType}/documentTypes?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(IDENTITY_FILES.MUTATIONS.GET_REQUIRED_DOCUMENT_TYPES, resp.data || [])
  },
  async [IDENTITY_FILES.ACTIONS.EDIT_REQUEST_FILE_METADATA]  ({ commit }, fileInfo) {
    commit(IDENTITY_FILES.MUTATIONS.EDIT_REQUEST_FILE_METADATA, fileInfo)
  },
  async [IDENTITY_FILES.ACTIONS.CLEAR_REQUIRED_DOCUMENT_TYPES] ({ commit }) {
    commit(IDENTITY_FILES.MUTATIONS.CLEAR_REQUIRED_DOCUMENT_TYPES)
  },
  async [IDENTITY_FILES.ACTIONS.CLEAR_REQUEST_FILES] ({ commit }) {
    commit(IDENTITY_FILES.MUTATIONS.CLEAR_REQUEST_FILES)
  },
  async [IDENTITY_FILES.ACTIONS.CLEAR_SINGLE_IDENTITY_FILE] ({ commit }) {
    commit(IDENTITY_FILES.MUTATIONS.CLEAR_SINGLE_IDENTITY_FILE)
  }
}
const mutations = {
  [IDENTITY_FILES.MUTATIONS.ADD_FILE_TO_STORE_LIST] (state, requestFiles) {
    if (!state[IDENTITY_FILES.STATE.REQUEST_FILES]) { state[IDENTITY_FILES.STATE.REQUEST_FILES] = [] }
    if (state[IDENTITY_FILES.STATE.REQUEST_FILES].length === 0) {
      state[IDENTITY_FILES.STATE.REQUEST_FILES].push(requestFiles)
    } else {
      const fileInfo = state[IDENTITY_FILES.STATE.REQUEST_FILES].find(el => el.documentType === requestFiles.documentType)
      const newInfo = {
        ...fileInfo,
        ...requestFiles,
        signature: null
      }
      const filtered = state[IDENTITY_FILES.STATE.REQUEST_FILES].filter(el => el.documentType !== requestFiles.documentType)
      filtered.push(newInfo)
      state[IDENTITY_FILES.STATE.REQUEST_FILES] = filtered
    }
  },
  [IDENTITY_FILES.MUTATIONS.EDIT_REQUEST_FILE_METADATA] (state, requestFiles) {
    if (!requestFiles.documentType) {
      return
    }
    const fileInfo = state[IDENTITY_FILES.STATE.REQUEST_FILES].find(el => el.documentType === requestFiles.documentType)
    if (!fileInfo) {
      return
    }
    const newInfo = {
      ...fileInfo,
      data: requestFiles.data
    }
    const filtered = state[IDENTITY_FILES.STATE.REQUEST_FILES].filter(el => el.documentType !== requestFiles.documentType)
    filtered.push(newInfo)
    state[IDENTITY_FILES.STATE.REQUEST_FILES] = filtered
  },
  [IDENTITY_FILES.MUTATIONS.DELETE_FILE_FROM_STORE_LIST] (state, fileId) {
    if (!state[IDENTITY_FILES.STATE.REQUEST_FILES]) {
      state[IDENTITY_FILES.STATE.REQUEST_FILES] = []
    }
    if (state[IDENTITY_FILES.STATE.REQUEST_FILES].length === 0) {

    } else {
      const filtered = state[IDENTITY_FILES.STATE.REQUEST_FILES].filter(el => el.fileId !== fileId)

      state[IDENTITY_FILES.STATE.REQUEST_FILES] = filtered
    }
  },
  [IDENTITY_FILES.MUTATIONS.GET_REQUIRED_DOCUMENT_TYPES] (state, requestDocumentTypes) {
    state[IDENTITY_FILES.STATE.REQUIRED_DOCUMENT_TYPES] = requestDocumentTypes
  },
  [IDENTITY_FILES.MUTATIONS.UPLOAD_SINGLE_IDENTITY_FILE] (state, file) {
    state[IDENTITY_FILES.STATE.CURRENT_FILE] = file
  },
  [IDENTITY_FILES.MUTATIONS.GET_REQUEST_FILES] (state, requestFiles) {
    state[IDENTITY_FILES.STATE.REQUEST_FILES] = requestFiles
  },
  [IDENTITY_FILES.MUTATIONS.CLEAR_REQUIRED_DOCUMENT_TYPES] (state) {
    state[IDENTITY_FILES.STATE.REQUIRED_DOCUMENT_TYPES] = []
  },
  [IDENTITY_FILES.MUTATIONS.CLEAR_REQUEST_FILES] (state) {
    state[IDENTITY_FILES.STATE.REQUEST_FILES] = []
  },
  [IDENTITY_FILES.MUTATIONS.CLEAR_SINGLE_IDENTITY_FILE] (state) {
    state[IDENTITY_FILES.STATE.CURRENT_FILE] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
